<template>
<div >
    <top-head @anchorTo="anchorTo" />
    <div class="intro-content">
        <el-carousel trigger="click" :height="bannerHeight+'px'" :autoplay="true" arrow="never">
            <el-carousel-item v-for="item in 3" :key="item" :style="{ height: bannerHeight+'px'}">
                <img class="bannerImg" style="width: 100%;" :src="getImgUrl('banner-'+item)"/>
            </el-carousel-item>
        </el-carousel>
        <div class="intro-content-wrap">
            <ul class="top-nav" id="introNavs">
                <li v-for="item in navLists" :key="item.key" @click="anchorTo(item.key)" :class="{'isActive': item.key === activeNav}">{{ item.label }}</li>
            </ul>
            <div class="intro-wrap1 intro-section" ref="intro1">
                <img class="intro-section-bg" src="../../../static/images/introduce/intro-bg.gif" />
                <section>
                    <h4>BETTA GAMES</h4>
                    <p>北京贝塔科技有限公司创立于2011年，专注移动游戏的研发和发行，是面向全球的游戏厂商。迄今推出Word Crossy，Mergical，Word Crush等多款畅销产品，全球累计注册用户超5亿，覆盖欧美、日韩、东南亚等全球100多个国家和地区。</p>
                    <p>创立十年来，贝塔科技致力于千万日活，亿万笑脸的美好愿景，为全世界的玩家创造快乐。</p>
                </section>
            </div>
            <div class="intro-wrap2 intro-section" ref="intro2">
                <img class="intro-section-bg" src="../../../static/images/introduce/mission-new-1.jpg" />
            </div>
            <div class="intro-wrap3 intro-section" ref="intro3">
                <img class="intro-section-bg" src="../../../static/images/introduce/mission-new-2.jpg" />
            </div>
            <div class="intro-wrap4 intro-section" ref="intro4">
                <img class="intro-section-bg" :src="getImgUrl(activeSite+'-bg')" />
                <div class="intro-wrap-content">
                    <div class="button">
                        <span v-for="(v, k) in site" :key="k" :class="{'isActive': activeSite === k}" @click="handleClick(k)">{{ v.label }}</span>
                    </div>
                    <p class="item">{{ site[activeSite].text }}<br/>(+86) 010 62927872</p>
                    <p class="item">商业合作:<br/>zhangnan@fotoable.com</p>
                    <p class="item">职位申请:<br/>career@fotoable.com</p>
                </div>
            </div>
        </div>
    </div>
    <homeFoot />
</div>
</template>
<script>
import routerLists from '@/router/routerLists';
import topHead from '../parts/headPart';
import homeFoot from '../parts/homeFoot.vue'
export default {
    name: 'introduce',
    components: {
        topHead,
        homeFoot,
    },
    data() {
        return {
            routerLists,
            activeNav: 'intro1',
            activeSite: 'beijing',
            isClick: false,
            bannerHeight: 640,
            site: {
                beijing: {
                    label: '北京区',
                    text: '中关村东升科技园B6号楼C座3-4层/A座5层'
                },
                chengdou: {
                    label: '成都区',
                    text: '成都市天府三街腾讯大厦B座308'
                }
            }
        }
    },
    computed: {
        navLists () {
            return this.routerLists.find(o => o.key === 'introduce').children || [];
        },
        active () {
            return this.$route.query.active;
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scrollTo, true);
    },
    mounted() {
        this.active? this.anchorTo(this.active) : undefined;
        window.addEventListener("scroll",this.scrollTo, true);
        window.onresize = () => {
            this.bannerHeight = document.querySelector('.bannerImg').offsetHeight;
        };
        this.getBannerImg();
    },
    methods: {
        getBannerImg () {
            let timer = setTimeout(() => {
                clearTimeout(timer);
                this.bannerHeight = document.querySelector('.bannerImg').offsetHeight;
                if(this.bannerHeight === 0) {
                    this.getBannerImg();
                }
            }, 50)
        },
        handleClick (val) {
            this.activeSite = val;
        },
        scrollTo: function (e) {                  
            let scrollTop = window.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
            let _h = document.querySelector('.intro-section').offsetHeight;
            let dom = document.getElementById('introNavs');
            let timer = null;
            if(scrollTop >= this.bannerHeight && dom) {
                dom.style.position = 'fixed';
                if(scrollTop >= this.bannerHeight+_h*3-100) {
                    this.activeNav = 'intro4';
                } else if(scrollTop >= this.bannerHeight+_h*2-100) {
                    this.activeNav = 'intro3';
                } else if(scrollTop > this.bannerHeight+_h-100) {
                    this.activeNav = 'intro2';
                } else {
                    this.activeNav = 'intro1';
                }
                history.pushState({}, null, '?active='+this.activeNav);
            } else {
                dom.style.position = 'absolute';
                history.pushState({}, null, '?');
            }
        },
        topAnchorTo (o) {
            const { page, key } = o;
            this.$router.push('/'+page);
        },
        anchorTo (ref) {
            this.isClick = true;
            let index = ref.split('intro')[1];
            this.$nextTick(() => {// behavior: "smooth", 
                this.$refs[ref].scrollIntoView({alignToTop:true});
            })
        },
        getImgUrl (item) {
            return require('../../../static/images/introduce/'+item+'.jpg'); 
        },
    }
}
</script>
<style scoped lang="less">
.center() {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.intro-section {
    position: relative;
    color: #fff;
    text-align: center;
    overflow: hidden;
    font-size: 0;
    h4 {
        font-weight: 400;
    }
}
.intro-section-bg {
    width: 100%;
}
.intro-wrap1 {
    section {
        .center();
        width: 1080px;
        font-size: 14px;
        text-align: left;
    }
    h4 {
        font-size: 36px;
        margin-bottom: 48px;
    }
    p {
        width: 617px;
        margin-bottom: 20px;
    }
}
.intro-wrap2 {
    position: relative;
    .mission-bg-text {
        .center();
        width: 555px;
    }
}
.intro-wrap3 {
    position: relative;
    .intro-wrap3-content{
        width: 100%;
        font-size: 24px;
        .center();
    }
    .section {
        position: relative;
        text-align: center;
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            transform: translate(-50%, -50%);
            h4 { 
                font-size: 36px; 
                margin-bottom: 36px;
            }
            span {
                padding: 0 40px;
            }
        }
    }
}
.intro-wrap4 {
    position: relative;
    font-size: 20px;
    line-height: 32px;
    .intro-wrap-content {
        .center();
    }
    .button {
        text-align: center;
        margin-bottom: 60px;
        span {
            cursor: pointer;
            display: inline-block;
            width: 149px;
            height: 52px;
            font-size: 24px;
            border: 1px solid #fff;
            line-height: 52px;
            box-sizing: border-box;
            margin: 0 21px;
            position: relative;
            transition: .3s;
            -webkit-transition: .3s;
            &.isActive, &:hover {
                color: #2E2E2E;
                background: #fff;
            }
        }
    }
    .item {
        margin-bottom: 55px;
    }
}
.intro-content-wrap {
    position: relative;
}
.top-nav {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    background: #1D1D1D;
    z-index: 9;
    min-width: 1200px;
    margin: 0 auto;
    li {
        cursor: pointer;
        display: inline-block;
        width: 270px;
        height: 42px;
        color: #fff;
        font-size: 14px;
        line-height: 42px;
        &.isActive {
            background: #1F4BBA;
        }
    }
}
</style>
<style lang="less">
.intro-content {
    .el-carousel__indicator {
        width: 60px;
        height: 5px;
        margin: 0 6px;
        padding: 0;
        .el-carousel__button {
            width: 100%;
            height: 100%;
        }
    }
    .el-carousel__button {
        background: #fff;
        opacity: 0.4;
    }
    .el-carousel__indicators--horizontal .el-carousel__indicator.is-active button {
        background: #fff;
        opacity: 1;
    }
    .el-carousel__indicators--horizontal {
        bottom: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/introduce.vue